<script module lang="ts">
  import type { SectionStoryblok } from "~/component-types-sb";
  import type { Snippet } from "svelte";
  export interface SectionStoryblokProps {
    blok: SectionStoryblok;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { storyblokEditable, StoryblokComponent } from "@storyblok/svelte";
  import { Section } from "@agapi/ui/section";
  import { css, type Styles } from "@agapi/ui/panda/css";
  import { sectionStyles } from "./section.styles";

  const { blok, children, ...props }: SectionStoryblokProps  = $props();

  const classes = sectionStyles.raw({direction: blok.direction, verticalSpacing: blok.vertical_spacing})

  const extraStyles: Styles = {}
  if (blok.bottomPadding) {
    extraStyles.pb = blok.bottomPadding;
  }
  const rootStyles = css.raw(classes.root, extraStyles);
</script>

<Section
  use={[ [storyblokEditable, blok ] ]}
  {...props}
  containerWidth={blok.container_width as "tight" | "normal" | "wide" | "slim" | undefined}
  rootStyles={rootStyles}
  containerStyles={classes.container}
  colorVariant={blok.color_variant}
>
  {#each blok?.content ?? [] as item}
    <StoryblokComponent blok={item} />
  {/each}
</Section>
